<template>
    <section class="content-header">
        <slot name="titulo">
            <h1>
                <i v-if="icone" :class="icone" />
                {{ titulo }}
            </h1>
        </slot>
        <ol class="breadcrumb">
            <li>
                <b-link 
                    v-if="itens.length > 0" 
                    :href="dashboardUrl"
                    @click.prevent="acessarInicio"
                >
                    <i class="fa fa-home" />
                    Início
                </b-link>
                <div v-else>
                    <span class="active">
                        <i class="fa fa-home" />
                        Início
                    </span>
                </div>
            </li>
            <li v-for="(item, index) in itens" :key="index" :class="index == itens.length - 1 ? 'active' : ''">
                <template v-if="item.url">
                    <b-link v-if="item.tipo === 'href'" :href="item.url">
                        {{ item.descricao }}
                    </b-link>
                    <router-link v-else :to="item.url">
                        {{ item.descricao }}
                    </router-link>
                </template>
                <template v-else>
                    {{ item.descricao }}
                </template>
            </li>
        </ol>
    </section>
</template>

<script>
import { acessaDashboard, pegaUrlDashboard } from '@/shared/common/functions/dashboard'
export default {
    name: 'BarraTitulo',
    props: {
        titulo: {
            type: String,
            required: true
        },
        icone: {
            type: String,
            required: false,
            default: ''
        },
        itens: {
            type: Array,
            required: true
        }
    },
    computed: {
        dashboardUrl() {
            return pegaUrlDashboard();
        },
    },
    methods: {
        acessarInicio() {
            acessaDashboard(this.dashboardUrl);
        },
    }
}
</script>
